export default __webpack_public_path__ + "static/media/bias_img_bone_0.422f288f.png";